import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { CustomRestService } from '@service/customRest/custom-rest.service';
import { CsvUtilService } from '@service/csv-util/csv-util.service';
import { UploadCsvDialogComponent } from './upload-csv-dialog/upload-csv-dialog.component';
import { UrlService } from '@service/url/url.service';
import { IS_NOT_EMPTY, RestService } from 'cargo-chief-commons';
import {
	GET_BUCKET_NAME,
	IS_VALID_LINE,
	MAP_HEADERS,
	MAP_INDICES,
} from '@service/csv-util/shared/utils';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-upload-csv',
	templateUrl: './upload-csv.component.html',
	styleUrls: ['./upload-csv.component.scss'],
})
export class UploadCsvComponent implements OnInit {
	@Input() label: string;
	@Input() dataType: string;
	@Input() fullWidth: boolean;
	@Input() useInputFileName: boolean = false;
	@Input() isMenuButton = false;
	@Input() title: string = 'Upload CSV file';
	@Input() labelClass: string = '';
	@Input() subtitle: string = '';
	@Input() secondStepTitle: string = '';
	@Input() thirdStepTitle: string = '';
	@Input() appendUserDataToFileName: boolean = false;

	@Output() fileUploadedEvent = new EventEmitter<string>();

	constructor(
		public dialog: MatDialog,
		private csvUtilService: CsvUtilService,
		private urlService: UrlService,
		private restService: RestService,
		private customRestService: CustomRestService,
		public utilService: UtilService
	) {}

	ngOnInit() {}

	openDialog() {
		const dialogRef = this.dialog.open(UploadCsvDialogComponent, {
			width: '95vw',
			maxWidth: '1400px',
			maxHeight: '90vh',
			panelClass: 'upload-csv-dialog',
			data: {
				dataType: this.dataType,
				title: this.title,
				subtitle: this.subtitle,
				secondStepTitle: this.secondStepTitle,
				thirdStepTitle: this.thirdStepTitle,
			},
		});

		dialogRef.afterClosed().subscribe(({ data, fileName }) => {
			if (data) {
				let csvData = this.formatFileData(data);
				let fileToUpload = this.generateFileFromCSVData(csvData, fileName);
				let uploadedFileName = this.useInputFileName ? fileName.split('.')[0] : '';
				if (IS_NOT_EMPTY(uploadedFileName) && this.appendUserDataToFileName) {
					uploadedFileName = this.csvUtilService.appendUserDataToFileName(
						uploadedFileName.split('.')[0]
					);
				}
				const url = this.urlService.signedUrl(
					GET_BUCKET_NAME(this.csvUtilService.dataMap, this.dataType),
					uploadedFileName
				);
				this.restService.GET(url).subscribe((result) => {
					this.uploadCSVFileToS3PreSignedUrl(result['data'], result['objectKey'], fileToUpload);
				});
			}
		});
	}

	uploadCSVFileToS3PreSignedUrl(signedUrl: string, objectId: string, fileToUpload: any) {
		this.customRestService.uploadCsvFileToS3(signedUrl, fileToUpload).subscribe(
			(_) => {
				this.fileUploadedEvent.emit(objectId);
			},
			(error) => {
				if (error.status == 200) {
					this.fileUploadedEvent.emit(objectId);
				} else {
					this.utilService.showSnackbar(
						error.data || 'Unable to upload now.',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
				}
			}
		);
	}

	formatFileData(allLines: string[]) {
		let csvData = '';
		let indicesMap = MAP_INDICES(allLines[0].split(','));

		for (var i = 0; i < allLines.length; i++) {
			let line = allLines[i];
			if (i == 0) {
				MAP_HEADERS(line.split(','));
			}
			if (
				IS_VALID_LINE(line, indicesMap, this.csvUtilService.dataMap[this.dataType].requiredHeaders)
			) {
				let data = line.split(',');
				let row = '';
				let lastIndex = data.length - 1;
				for (var j = 0; j < data.length; j++) {
					let cellContent = data[j];
					row += cellContent.trim() + (j !== lastIndex ? ',' : '\n');
				}
				csvData += row;
			}
		}
		return csvData;
	}

	generateFileFromCSVData(csvFileData, fileName) {
		var blob = new Blob([csvFileData], { type: 'text/csv;charset=utf-8;' });
		return new File([blob], fileName);
	}
}
